(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["deco-tailles"] && !Shopify.designMode) return;
  try {
    // Survol d'une pastille : son nom remplace celui de la couleur affichée à côté du titre, puis revient.
  (() => {
    const montre = (e, sortie) => {
      const p = e.target.closest && e.target.closest('[data-decli-nom]');
      if (!p) return;
      const ligne = p.closest('.deco-decli__row, .deco-nuancier');
      const valeur = ligne && ligne.querySelector('[data-decli-valeur]');
      if (!valeur) return;
      valeur.textContent = sortie ? valeur.dataset.decliValeur : p.dataset.decliNom;
    };
    document.addEventListener('mouseover', (e) => montre(e, false));
    document.addEventListener('mouseout', (e) => montre(e, true));

    // Rendus « modèle × tissu » : le tissu touché remplace la grande photo (calque au-dessus de la galerie, fermable) ;
    // si la galerie est hors de l'écran à ce moment-là, un aperçu s'affiche aussi dans le nuancier.
    const fondPhotos = () => {
      const img = document.querySelector('media-gallery slideshow-slide img');
      return img ? getComputedStyle(img.parentElement).backgroundColor : '';
    };
    const fermerRendu = () => {
      document.querySelectorAll('.deco-rendu-galerie').forEach((x) => (x.hidden = true));
      document.querySelectorAll('[data-rendu-apercu]').forEach((x) => (x.hidden = true));
      document.querySelectorAll('.deco-nuancier--apercu .is-vu').forEach((x) => x.classList.remove('is-vu'));
    };
    const montrerRendu = (choix) => {
      const n = choix.closest('.deco-nuancier');
      const url = choix.dataset.rendu || '';
      const nom = choix.dataset.decliNom;
      const legende = url
        ? (choix.dataset.renduType === 'P' ? 'Photo · ' : 'Rendu indicatif · ') + nom
        : nom + ' · rendu à venir, tissu visible au showroom';
      const fond = fondPhotos();
      const sc = document.querySelector('media-gallery slideshow-container');
      let ov = sc && sc.querySelector('.deco-rendu-galerie');
      if (url && sc) {
        if (!ov) {
          ov = document.createElement('div');
          ov.className = 'deco-rendu-galerie';
          ov.innerHTML =
            '<img alt=""><span class="deco-rendu-galerie__legende"></span>' +
            '<button type="button" class="deco-rendu-galerie__fermer" aria-label="Revenir aux photos du produit">×</button>';
          ov.querySelector('button').addEventListener('click', (e) => {
            e.stopPropagation();
            fermerRendu();
          });
          sc.appendChild(ov);
        }
        ov.style.background = fond;
        ov.querySelector('img').src = url;
        ov.querySelector('img').alt = legende;
        ov.querySelector('.deco-rendu-galerie__legende').textContent = legende;
        ov.hidden = false;
      } else if (ov) {
        ov.hidden = true;
      }
      const fig = n.querySelector('[data-rendu-apercu]');
      if (fig) {
        const r = sc ? sc.getBoundingClientRect() : null;
        const visible = r && r.height ? Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0)) / r.height : 0;
        const cadre = fig.querySelector('.deco-rendu__cadre');
        const img = fig.querySelector('[data-rendu-img]');
        fig.querySelector('[data-rendu-legende]').textContent = legende;
        cadre.style.background = fond;
        cadre.hidden = !url;
        if (url) {
          img.src = url;
          img.alt = legende;
        }
        fig.hidden = Boolean(url) && visible >= 0.6;
      }
      if (n.classList.contains('deco-nuancier--apercu')) {
        n.querySelectorAll('.is-vu').forEach((x) => x.classList.remove('is-vu'));
        choix.classList.add('is-vu');
        const v = n.querySelector('[data-decli-valeur]');
        if (v) {
          v.dataset.decliValeur = nom;
          v.textContent = nom;
        }
      }
    };
    document.addEventListener('click', (e) => {
      if (!e.target.closest) return;
      const c = e.target.closest('.deco-nuancier__choix--vue');
      if (c) montrerRendu(c);
      // une vignette ou une flèche de la galerie : on revient aux vraies photos
      else if (e.target.closest('media-gallery') && !e.target.closest('.deco-rendu-galerie')) {
        document.querySelectorAll('.deco-rendu-galerie').forEach((x) => (x.hidden = true));
      }
    });
    document.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('deco-nuancier__choix--vue')) {
        e.preventDefault();
        montrerRendu(e.target);
      }
    });

    // Tissu au choix : le tissu coché s'affiche à côté du titre ; sans choix, l'ajout au panier est bloqué
    // (champ obligatoire) et le nuancier se montre avec un message, à la place de la bulle du navigateur.
    document.addEventListener('change', (e) => {
      const r = e.target;
      if (!r.classList || !r.classList.contains('deco-nuancier__radio')) return;
      const n = r.closest('[data-nuancier]');
      const v = n.querySelector('[data-nuancier-valeur]');
      // le nom affiché (« Be lovely cream ») ; la valeur envoyée reste la référence du portail (« Be lovely 11 cream »)
      const nom = r.closest('[data-decli-nom]').dataset.decliNom;
      v.dataset.decliValeur = nom;
      v.textContent = nom;
      n.querySelector('[data-nuancier-erreur]').hidden = true;
      if (n.querySelector('[data-rendu-apercu]')) montrerRendu(r.closest('.deco-nuancier__choix'));
    });
    let dernier = 0;
    document.addEventListener('invalid', (e) => {
      const r = e.target;
      if (!r.classList || !r.classList.contains('deco-nuancier__radio')) return;
      e.preventDefault();
      const n = r.closest('[data-nuancier]');
      n.querySelector('[data-nuancier-erreur]').hidden = false;
      if (Date.now() - dernier > 800) {
        dernier = Date.now();
        n.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
